import formatter from '@/services/Formatter'

export default {
  methods: {
    formatCurrency: formatter.formatCurrency,
    formatNumber: formatter.formatNumber,
    customFormat: formatter.customFormat
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Formatter.js